import { createSelector } from "reselect";

export const Types = {
  GET_REQUEST: "commercialCampaign/GET_REQUEST",
  GET_SUCCESS: "commercialCampaign/GET_SUCCESS",
  GET_FAILURE: "commercialCampaign/GET_FAILURE",

  GET_LIST_REQUEST: "commercialCampaign/GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "commercialCampaign/GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "commercialCampaign/GET_LIST_FAILURE",

  UPDATE_REQUEST: "commercialCampaign/UPDATE_REQUEST",
  UPDATE_SUCCESS: "commercialCampaign/UPDATE_SUCCESS",
  UPDATE_FAILURE: "commercialCampaign/UPDATE_FAILURE",
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,
};

export default function commercialCampaign(state = initialState, action) {
  switch (action.type) {
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.commercialCampaign.data,
        page: action.payload.commercialCampaign.meta.current_page,
        totals: action.payload.commercialCampaign.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}

export const Creators = {
  getComercialCampaignsRequest: (page = 1, per = 9000, active = undefined) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, per, active },
  }),

  getComercialCampaignsSuccess: (commercialCampaign) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { commercialCampaign },
  }),

  getComercialCampaignsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),
};

export const Selectors = {
  list: createSelector(
    (state) => state,
    (campaigns) =>
      campaigns.map((campaign) => ({
        value: campaign.id,
        label: campaign.attributes.title,
      }))
  ),
};
